import { catalogItemsSortOrders } from '@/enums';
import { AuctionStatus } from '@/types/LiveAuctionState';
import { SearchSortAndDirection } from '@/types/search/enums/sortTypes';

type GetFilteredSortOrdersParams = {
    catalogStatus: AuctionStatus;
};

export const getFilteredSortOrders = ({ catalogStatus }: GetFilteredSortOrdersParams) => {
    let filteredSortOrders: SearchSortAndDirection[] = [...catalogItemsSortOrders];

    if (catalogStatus !== AuctionStatus.Done) {
        filteredSortOrders = filteredSortOrders.filter((sort) => sort !== SearchSortAndDirection.HammerPriceHighest);
    } else if (catalogStatus === AuctionStatus.Done) {
        filteredSortOrders = filteredSortOrders.filter((sortType: SearchSortAndDirection) => {
            return (
                sortType !== SearchSortAndDirection.PriceLowest &&
                sortType !== SearchSortAndDirection.PriceHighest &&
                sortType !== SearchSortAndDirection.MostRelevant &&
                sortType !== SearchSortAndDirection.NewlyListed &&
                sortType !== SearchSortAndDirection.Promoted &&
                sortType !== SearchSortAndDirection.MostBids
            );
        });
    }

    return filteredSortOrders;
};
